import { ModalOpenButton } from "@msys/ui";
import { Add as AddIcon } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import { useNavigate } from "react-router-dom";
import {
  namedOperations,
  ProjectSourcePageName,
} from "../../../clients/graphqlTypes.js";
import { ButtonCreate } from "../../commons/button/Button.js";
import { CreateProjectModal } from "../projects/modals/CreateProjectModal.js";
import React from "react";

export const CreateOpportunityButton = ({
  crmOrganisation,
  building,
  buildingItemId,
  pageName,
  refetchQueries,
  type,
  size = "small",
}: {
  crmOrganisation?: React.ComponentProps<
    typeof CreateProjectModal
  >["crmOrganisation"];
  building?: React.ComponentProps<typeof CreateProjectModal>["building"];
  buildingItemId?: string;
  pageName: ProjectSourcePageName;
  refetchQueries?: string[];
  type: "icon" | "button";
  size?: "small" | "large";
}) => {
  const { t } = useTranslate("Opportunities");
  const navigate = useNavigate();

  const title = t("Create opportunity");

  return (
    <ModalOpenButton
      Modal={CreateProjectModal}
      modalProps={{
        refetchQueries: [
          namedOperations.Query.OpportunitiesList,
          namedOperations.Query.OpportunitiesKanbanList,
          ...(refetchQueries ?? []),
        ],
        crmOrganisation,
        building,
        buildingItemId,
        pageName,
        handleComplete: async projectId => {
          navigate({
            pathname: `/projects/${projectId}/overview`,
            search: new URLSearchParams({ create: "true" }).toString(),
          });
        },
        desiredProjectInitialStatus: "opportunity",
      }}
    >
      {type === "button" ? (
        <ButtonCreate title={title} sx={{ flexShrink: 0, flexGrow: 0 }} />
      ) : type === "icon" ? (
        <IconButton
          color="primary"
          aria-label={title}
          size={size}
          sx={{ flexShrink: 0, flexGrow: 0 }}
        >
          <Tooltip title={title}>
            <AddIcon />
          </Tooltip>
        </IconButton>
      ) : (
        <div />
      )}
    </ModalOpenButton>
  );
};
